var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('list-view',{staticClass:"topic-board",class:{centered: _vm.centered},attrs:{"panels":_vm.panels,"fab":{path: '/tasks', icon: 'calendar_today'},"customizable":_vm.customizable}})}
var staticRenderFns = []

export { render, staticRenderFns }